<script>
export default {
  data() {
    return {
      table: {
        headers: [
          {
            text: this.$t('faq.documentProperties.header.x'),
            align: 'start',
            sortable: false,
            value: 'x',
            class: 'black white--text'
          },
          { text: this.$t('faq.documentProperties.header.y'), value: 'y', class: 'black white--text' },
          { text: this.$t('faq.documentProperties.header.width'), value: 'width', class: 'black white--text' },
          { text: this.$t('faq.documentProperties.header.height'), value: 'height', class: 'black white--text' },
          { text: this.$t('faq.documentProperties.header.content'), value: 'content', class: 'black white--text' }
        ],
        docProps: [
          {
            x: '0,0',
            y: '40,0',
            width: '11,0',
            height: '55,0',
            content: this.$t('faq.documentProperties.doc.props.production.notes')
          },
          {
            x: '0,0',
            y: '160,0',
            width: '14,0',
            height: '20,0',
            content: this.$t('faq.documentProperties.doc.props.production.notes')
          },
          {
            x: '18,5',
            y: '45,9',
            width: '73,0',
            height: '6,3',
            content: this.$t('faq.documentProperties.doc.props.sender.line')
          },
          {
            x: '18,5',
            y: '52,2',
            width: '73,0',
            height: '13,4',
            content: this.$t('faq.documentProperties.doc.props.postal.notes')
          },
          {
            x: '18,5',
            y: '65,6',
            width: '59,0',
            height: '0,9',
            content: this.$t('faq.documentProperties.doc.props.hyphen')
          },
          {
            x: '18,5',
            y: '66,5',
            width: '73,0',
            height: '23,8',
            content: this.$t('faq.documentProperties.doc.props.recipient')
          },
          {
            x: '77,5',
            y: '65,6',
            width: '14,0',
            height: '0,9',
            content: this.$t('faq.documentProperties.doc.props.hyphen')
          }
        ]
      }
    }
  }
}
</script>
<template>
  <v-data-table
    :headers="table.headers"
    :items="table.docProps"
    hide-default-footer
    dense
    class="elevation-1">
    <template #no-data>
      {{ $t('global.no.entries') }}
    </template>
    <template #footer>
      <td class="pt-2">
        <strong>{{ $t('faq.documentProperties.table.footer') }}</strong>
      </td>
    </template></v-data-table
  >
</template>
